import type { FaireProductEntity } from "../../entity_types/product";

export const p_dc95mtx7p8: FaireProductEntity = {
  token: "p_dc95mtx7p8",
  type: "product",
  name: "Dubai Chocolate Pistachio Wafers",
  brandToken: "b_2xjdvub937",
  brandName: "Ceres Gourmet",
  imageUrl:
    "https://cdn.faire.com/fastly/e277795c93ee18d0de350eefcef1a3bb6542341f9362ef55ad493ffb3716fa64.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca20bb37161f56f7dd60f82f50ae107756c86797cd30d9db173d15e16c56e421.jpeg",
    "https://cdn.faire.com/fastly/2c4b3f7d61f0d58b441cea42c0f954125522b2925935048d999db3b87eb76af9.jpeg",
    "https://cdn.faire.com/fastly/775f653ebe0c840d6f9e0b96c41244bafca8e5289c08b310910e718302f8082a.jpeg",
    "https://cdn.faire.com/fastly/c51ed6c9e3cf651dbd3d9c4938748f306f2bd7c7db060727627860e60f4c4f4f.jpeg",
    "https://cdn.faire.com/fastly/f3c18cf1bb11b4195eb38ae71fa165d8f79095d03f4cfc9535fc48e24e1359c8.jpeg",
    "https://cdn.faire.com/fastly/d3f1720aba197fa93833eeaa95d3593a16530d32487d102a20bb18a859086f92.jpeg",
  ],
  priceDollars: 2.2,
  description:
    "Dubai Chocolate Pistachio Wafer (with Crispy Kunafa)\nThis exclusive Dubai Chocolate Pistachio Wafers combine a rich pistachio cream filling with layers of crispy kunafa, all enveloped in high-quality chocolate. Crafted with care using premium ingredients, each piece is presented in elegant packaging—making it a perfect premium product for retail shelves, corporate events, or special occasions.\n\nProduct Highlights:\nWholesale-Friendly: Bulk pricing, fast shipping.\nDelicious Fusion: Creamy pistachio, crispy kunafa, and rich chocolate in every bite.\nElegant & Fresh: Individually wrapped for hygiene and freshness.\nPerfect for Gifting: Great for holidays, special occasions, and luxury gift sets.\nRetail-Ready: Ideal for gourmet shops, events, and corporate gifting.\n",
  tags: [],
  msrpDollars: 4.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:19.534Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
